import React, { useState, useEffect } from "react";
import Alert from "../../components/Alert";
import Breadcrumb from "../../parts/Breadcrumb";
import { Link } from "react-router-dom";
import { pluck, reject, contains } from "underscore";
import ListSection from "../../components/ListSection";
// import DeleteModel from "../../components/DeleteModel";
import labels from "../../constants/Withdraw";
import configuration from "../../config";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import { reactLocalStorage } from "reactjs-localstorage";
// List all users
function View({ location }) {
  const columns = [
    {
      title: "ID",
      field: "withdraw_request_id",
    },
    { title: "User ID", field: "user_id" },
    {
      title: "User Name",
      field: "first_name",
      render: (rowData) => (
        <span>{rowData.first_name + " " + rowData.last_name}</span>
      ),
    },
    {
      title: "Mobile",
      field: "mobile",
      render: (rowData) => (
        <span>{rowData.mobile_country_code + " " + rowData.mobile}</span>
      ),
    },
    { title: "Amount", field: "amount" },
    { title: "Date", field: "created_at" },
    {
      title: "User Type",
      field: "user_type",
      render: (rowData) => (
        <span className="capitalize">{rowData.user_type}</span>
      ),
    },
    {
      title: "Status",
      field: "status",
      render: (rowData) => (
        <span
          className={
            rowData.status === "approve"
              ? "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-green-100 text-green-800 capitalize"
              : "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-red-100 text-red-800 capitalize"
          }
        >
          {" "}
          {rowData.status === "approve" ? "approved" : "rejected"}
        </span>
      ),
    },
    {
      title: "Action",
      field: "status",
      width: "5%",
      render: (rowData) =>
        rowData.status === "pending" ? (
          <>
            <button
              onClick={(e) =>
                handleAction("approve", rowData.withdraw_request_id)
              }
              type="button"
              className="mt-3 mr-3 inline-flex items-center px-3 py-2 border border-transparent text-baseleading-4 font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Approve
            </button>
            <button
              onClick={(e) =>
                handleAction("reject", rowData.withdraw_request_id)
              }
              type="button"
              className="mt-3 inline-flex items-center px-3 py-2 border border-1 text-baseleading-4 font-medium rounded-md shadow-sm text-indigo-600 bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Reject
            </button>
          </>
        ) : (
          ""
        ),
    },
  ];
  const [data, setData] = useState([]);
  const [csvData, setcsvData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);

  const btnGroups = [
    // {
    //   id: 2,
    //   title: "Export CSV",
    //   type: "exportCSV",
    //   path: "/user",
    //   fileName: "Trips",
    // },
  ];
  const [show, setShow] = useState(false);
  // const [showModal, setShowModal] = useState(false);
  const fieldArr = [
    // {
    //   id: 3,
    //   title: "From  Date",
    //   name: "from_date",
    //   type: "DatePicker",
    //   disablePast: false,
    // },
    // {
    //   id: 4,
    //   title: "To Date",
    //   name: "to_date",
    //   type: "DatePicker",
    //   disablePast: false,
    // },
  ];
  const [fieldsFilter, setFieldsFilter] = useState({
    from_date: null,
    to_date: null,
  });
  const [errorsFilter, setErrorsFilter] = useState({
    from_date: "",
    to_date: "",
  });

  const [ids, setIds] = useState([]);

  useEffect(() => {
    getData({});
  }, []);

  function getData(filterData) {
    setIsLoader(true);
    configuration
      .getAPI({
        url: "sub-user/withdraw-list",
        params: { filterData: JSON.stringify(filterData) },
      })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setData(data.payload);
          // const formatted = data.payload.map((item) => ({
          //   ID: item.trip_id,
          //   Passenger: item.passenger_info,
          //   Driver: item.driver_info,
          //   Vehicle: item.vehicle_ride_option_info,
          //   Service: item.service_info,
          //   "Sub Total": item.subtotal,
          //   Total: item.total,
          //   "Book Date": item.booking_date,
          //   Status: item.status,
          // }));
          // setcsvData(formatted);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  const onSelectionChange = (e) => {
    let idArr = pluck(e, "user_id");
    setIds(idArr);
  };

  function handleApplyFilter() {
    if (handleFilterValidation()) {
      getData(fieldsFilter);
    }
  }
  function handleClearFilter() {
    setFieldsFilter({ status: [], from_date: null, to_date: null });
    setErrorsFilter({});
    getData({});
  }

  function handleChangeFilter(field, e) {
    if (field === "status") {
      console.log(field);
      console.log(e.target.value);
      let sessionData = fieldsFilter.status ? fieldsFilter.status : [];
      if (!contains(sessionData, e.target.value)) {
        sessionData.push(e.target.value);
      } else {
        sessionData = reject(sessionData, function (num) {
          return num === e.target.value;
        });
      }
      console.log(sessionData);
      setFieldsFilter({ ...fieldsFilter, [field]: sessionData });
      if (sessionData && sessionData.length <= 0) {
        delete fieldsFilter.status;
        getData({ fieldsFilter });
      } else {
        getData({ ...fieldsFilter, [field]: sessionData });
      }
    } else {
      setFieldsFilter({ ...fieldsFilter, [field]: e });
    }
  }
  function handleFilterValidation() {
    let flag = true;
    let error = {};
    if (fieldsFilter.to_date && !fieldsFilter.from_date) {
      error["from_date"] = "Please select from date";
      flag = false;
    }
    if (!fieldsFilter.to_date) {
      error["from_date"] = "Please select to date";
      flag = false;
    }
    if (!fieldsFilter.from_date) {
      error["from_date"] = "Please select from date";
      flag = false;
    }
    if (fieldsFilter.from_date && !fieldsFilter.to_date) {
      error["to_date"] = "Please select to date";
      flag = false;
    }
    if (fieldsFilter.from_date && fieldsFilter.to_date) {
      if (fieldsFilter.to_date < fieldsFilter.from_date) {
        flag = false;
        error["to_date"] = "Please select end date greater than to start date.";
      }
    }
    if (fieldsFilter.status && fieldsFilter.status.length <= 0) {
      delete fieldsFilter.status;
      setFieldsFilter(fieldsFilter);
    }
    setErrorsFilter({ ...error });
    return flag;
  }

  function handleAction(type, request_id) {
    setIsLoader(true);
    configuration
      .postAPI({
        url: "sub-user/withdraw-action",
        params: { type, withdraw_request_id: request_id },
      })
      .then((data) => {
        if (data.status === 200) {
          getData();
          setIsLoader(false);
          return toast.success(
            type === "approve"
              ? "The withdrawal request has been approved successfully."
              : "The withdrawal request has been rejected successfully."
          );
        } else if (data.error) {
          setIsLoader(false);
          return toast.error(data.error.message);
        } else {
          setIsLoader(false);
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }

  return (
    <>
      <Breadcrumb module={labels.Withdraw} />
      <Loader isOpen={isLoader} />
      <Alert
        show={show}
        setShow={setShow}
        bgColorClass="green"
        caption="Success"
        message="Record added successfully"
      />
      <ListSection
        captionTitle="View Withdrawal Requests"
        columns={columns}
        data={data}
        btnGroups={btnGroups}
        filters={false}
        fieldArr={fieldArr}
        disabledCheckbox={true}
        onSelectionChange={onSelectionChange}
        handleApplyFilter={handleApplyFilter}
        handleClearFilter={handleClearFilter}
        handleChangeFilter={handleChangeFilter}
        fieldsFilter={fieldsFilter}
        errorsFilter={errorsFilter}
        csvData={csvData}
        csvName={"Withdrawal-Requests"}
      />
    </>
  );
}

export default View;
